
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import MainLayout from '../components/layout/MainLayout';
import Hero from '../components/pages/Hero';
import EarnSection from '../components/pages/EarnSection';
import SpeedPrivacySection from '../components/pages/SpeedPrivacySection';
import MockupSection from '../components/pages/MockupSection';
import IntroSection from '../components/pages/IntroSection';
import ThreeFeaturesSection from '../components/pages/ThreeFeaturesSection';
import InvestLiquiditySection from '../components/pages/InvestLiquiditySection';
import EliteTradersSection from '../components/pages/EliteTradersSection';
import PrimeStrategySection from '../components/pages/PrimeStrategySection';
import EarnBeyondSection from '../components/pages/EarnBeyondSection';
import MoneyMovesSection from '../components/pages/MoneyMovesSection';
import DownloadAppSection from '../components/pages/DownloadAppSection';
import SecuritySection from '../components/pages/SecuritySection';
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import Footer from "../components/layout/Footer";
import Navigation from "../components/layout/Navigation";
import axios from "axios";
import Loader from "../components/Loader";
export default function Home() {
    const router = useRouter();
    const searchParams = new URLSearchParams(router.query).toString() || '';
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const organizationSchemaData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": `${process.env.NEXT_PUBLIC_SITE_URL}/#organization`,
        "name": seo.index_page.title,
        "alternateName": ["HFDX, Pay-Fi Revolution", "HFDX Platform"],
        "description": seo.index_page.description,
        "url": process.env.NEXT_PUBLIC_SITE_URL,
        "logo": {
            "@type": "ImageObject",
            "url": `${process.env.NEXT_PUBLIC_SITE_URL}/logo.png`,
            "width": 600,
            "height": 200,
            "caption": "HFDX platform logo"
        },
        "sameAs": [
            "https://t.me/HFDXTrading",
            "https://x.com/HfdxProtocol"
        ],
        "foundingDate": "2025",
        "knowsAbout": ["Blockchain Platform", "De-Fi Platform", "DEX", "Decentralized Gaming", "Smart Contract Development"],
        "areaServed": "Worldwide",
        "keywords": seo.index_page.keywords,
        "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Customer Support",
            "email": `support@${process.env.NEXT_PUBLIC_SITE_URL.replace('https://', '')}`,
            "availableLanguage": "English"
        }
    };
    const webSiteSchemaData = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": `${process.env.NEXT_PUBLIC_SITE_URL}/#website`,
        "name": "HFDX - Decentralized Perpetual Exchange",
        "url": process.env.NEXT_PUBLIC_SITE_URL,
        "publisher": {
            "@id": `${process.env.NEXT_PUBLIC_SITE_URL}/#organization`
        },
        "potentialAction": {
            "@type": "SearchAction",
            "target": {
                "@type": "EntryPoint",
                "urlTemplate": `${process.env.NEXT_PUBLIC_SITE_URL}/faqs?q={search_term_string}`
            },
            "query-input": "required name=search_term_string"
        }
    };
    const [apiData, setApiData] = useState({
        open_interest: "0",
        total_future_markets: 0,
        volume_24h: "0"
    });
    const getData = async () => {
        return await axios.get('/api/get-data', {
            headers: {
                "Content-Type": "application/json"
            }
        });
    };
    useEffect(() => {
        let appLoading = new Promise((resolve, reject) => {
            setTimeout(resolve, 2000, true);
        });
        let apiData = getData().then(data => {
            setApiData(data.data);
        }).catch(() => {
            setApiData({
                open_interest: "0",
                total_future_markets: 0,
                volume_24h: "0"
            });
        });
        Promise.all([appLoading, apiData]).then(values => {
            setIsLoading(false);
            setLoaded(true);
        });
    }, []);
    return (<MainLayout loaded={loaded} title={seo.index_page.title} description={seo.index_page.description} keywords={seo.index_page.keywords} page={'index'} alternate={''} canonical={'/'} organizationSchemaData={organizationSchemaData} webSiteSchemaData={webSiteSchemaData}>
            <Navigation />
            <main className='main' style={{ overflowX: 'hidden' }}>
                <Hero apiData={apiData}/>
                <EarnSection />
                <SpeedPrivacySection />
                <MockupSection />
                <IntroSection />
                <ThreeFeaturesSection />
                <InvestLiquiditySection />
                <EliteTradersSection />
                <PrimeStrategySection />
                <EarnBeyondSection />
                <MoneyMovesSection />
                <DownloadAppSection />
                <SecuritySection />
            </main>
            <Footer t={t}/>
            <Loader isLoading={isLoading} loaded={loaded}/>
        </MainLayout>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f1e4__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f1e4__ as getStaticProps }
  